'use client';

import './project-mobile-detail.scss';
import { ProjectModel } from "@/lib/models/Project";
import ImageElement from '@/components/elements/ImageElement';
import MobileNavigationBar from '@/components/Mobile/MobileNavigationBar';
import { useContext, useRef } from 'react';
import { ROUTES } from '@/lib/routes';
import MobileShellContext from '@/components/Mobile/MobileShellContext';
import { projectSlideIndex } from '@/components/Mobile/Home/slides';
import { useTransitionExit } from '@/components/Mobile/Transition/RouteTransition';
import VideoElement from '@/components/elements/VideoElement';
import { getMediaKind } from '@/lib/utils/mediaKind';
import { useVerticalSwipe } from '@/lib/hooks/useVerticalSwipe';

const SWIPE_DOWN_THRESHOLD_PX = 150;

interface Props {
  project: ProjectModel;
  projects: ProjectModel[];
}

const ProjectDetailMobile = ({ project, projects }: Props) => {
  const { setSlide } = useContext(MobileShellContext);

  const exit = useTransitionExit();

  const projectRef = useRef<HTMLDivElement>(null);

  const goBack = () => {
    const projectIdx = projects.findIndex(p => p.id === project.id);
    if (projectIdx > -1) setSlide(projectSlideIndex(projectIdx));
    exit(`${ROUTES.home}`);
  };

  // Handle swipe navigation
  const { onTouchStart, onTouchEnd } = useVerticalSwipe({
    onSwipeDown: goBack,
    threshold: SWIPE_DOWN_THRESHOLD_PX,
    requireAtTop: projectRef,
  });

  const renderImage = (link: string, index: number) => {
    return (
      <div className="project-image-container" key={index}>
        <ImageElement
          src={link}
          className='project-image'
          alt={""}
          scroller={projectRef}
          priority={index === 0}
        />
      </div>
    )
  };

  const renderVideo = (link: string, index: number) => {
    return (
      <div className='project-image-container' key={index}>
        <VideoElement
          src={link}
          className='project-image'
          scroller=".project-mobile-detail"
        />
      </div>
    );
  };

  return (
    <>
      <div className={'project-mobile-detail'}
        ref={projectRef}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <div className={'project-description-container'} id={'header-project-detail-mobile'}>
          <p className={'text-experiment'}>EXPERIMENT</p>
          <p className={'text-name-project'}>{project.projectTitle}</p>
          <p className={'text-description-project'}>{project.projectDescription}</p>
        </div>
        {
          // Render project images and videos...
          project.projectMedia.map((item, index) => {
            if (getMediaKind(item) === 'video') {
              return renderVideo(item, index)
            } else {
              return renderImage(item, index)
            }
          })
        }

        <div className='end-project-item'>
          <span className='icon-warning'><WarningIcon /></span>
          End of Experiment
        </div>
      </div>
      <MobileNavigationBar onBack={goBack} />
    </>
  )
};

function WarningIcon() {
  return (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M512 64L32 928h960L512 64zm0 176l352 624H160l352-624zm-40 208v224h80V448h-80zm0 288v80h80v-80h-80z" />
    </svg>
  );
}

export default ProjectDetailMobile;
